module.exports = __webpack_public_path__ + "img/fnslab.f24af415.svg";